import {WebFormModel} from "capitalist-shared/src/core/model";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import {CryptoAddress} from "@/models/finance/crypto";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
import {CurrencyCode} from "@/models/core/currency";

export class DepositUsdtCardtransferModel extends WebFormModel {

  initStatus = new RemoteRequestState()
  submitStatus = new RemoteRequestState()
  recreateStatus = new RemoteRequestState()
  selectedAddress: CryptoAddress | null = null;

  minimum = 3000
  maximum = 49000
  addresses = []
  accounts = []

  options = {
    avail: false
  }

  values = {
    amount: '',
    address: '',
    account: '',
    pan: ''
  }

  loadModel() {
    this.initStatus.loadStart()
    return httpAxiosApi.post('/webapi/finance/usdtdeposit', {
      call: 'loadModel'
    }).then(result => {
      this.initStatus.loadEnd()
      this.accounts = result.data.model.options.accounts
      if (this.accounts.length > 0) {
        this.values.account = this.accounts[0].number
      }
      this.addresses = result.data.model.options.addresses.map((obj) => CryptoAddress.createFromData(obj))
      this.options.avail = result.data.model.options.avail
      if (this.options.avail && (this.addresses.length == 0)) {
        throw new Error('address not found')
      }
      if (this.addresses.length > 0) {
        this.values.address = this.addresses[0].address
        this.selectedAddress = this.addresses[0]
      }
      return result.data.model
    }).catch(err => {
      this.initStatus.loadError()
      throw err
    })
  }

  submit() {
    this.errors.clear()
    this.submitStatus.loadStart()
    return httpAxiosApi.post('/webapi/finance/usdtdeposit', {
      call: 'depositUsdtDirectUrl',
      m: this.values
    }).then(result => {
      this.submitStatus.loadEnd()
      return result.data
    }).catch(err => {
      this.checkAxiosError(err)
      this.submitStatus.loadError()
      throw err
    })
  }
}


export class DepositUsdtTransferModel extends WebFormModel {

  initStatus = new RemoteRequestState()
  recreateStatus = new RemoteRequestState()
  selectedAddress: CryptoAddress | null = null;

  get selectedAccount() {
    return this.accounts.find(account => account.number == this.values.account)
  }

  addresses = []
  accounts = []

  options = {
    avail: false
  }

  values = {
    address: '',
    account: ''
  }

  loadModel() {
    this.initStatus.loadStart()
    return httpAxiosApi.post('/webapi/finance/deposit', {
      call: 'legacy',
      system: 'usdt'
    }).then(result => {
      this.initStatus.loadEnd()
      this.accounts = result.data.model.options.accounts
      if (this.accounts.length > 0) {
        this.values.account = this.accounts[0].number
      }
      this.addresses = result.data.model.options.addresses.map((obj) => CryptoAddress.createFromData(obj))
      this.options.avail = result.data.model.options.avail
      if (this.options.avail && (this.addresses.length == 0)) {
        throw new Error('address not found')
      }
      this.autoselectAddress();
      return result.data.model
    }).catch(err => {
      this.initStatus.loadError()
    })
  }

  autoselectAddress(showHidden = true) {
    if (this.selectedAccount?.currency)
    {
      const addr = this.getClosestAddressForAccountCurrency(this.selectedAccount.cryptoCurrency, showHidden);
      // console.log('autoselectAddress', addr);
      this.values.address = addr?.address
      this.selectedAddress = addr
    } else {
      // console.log('autoselectAddress', null);
      this.values.address = ''
      this.selectedAddress = null
    }
  }

  getVisibleAddresses(showHidden = true) {
    return (this.addresses || []).filter(address => !address.hidden || showHidden)
  }

  onAccountChange(showHidden = true) {
    this.autoselectAddress(showHidden);
  }

  getClosestAddressForAccountCurrency(currency: CurrencyCode = null, showHidden = true) {
    const addresses = this.getVisibleAddresses(showHidden)?.filter(address => !currency || (address.currency === currency)) || [];

    const addr = addresses?.find(address => {
        return address.autoConvertAccountNumber
          && String(address.autoConvertAccountNumber).startsWith('UCP')
      })
      || addresses?.find(address => {
        return address.autoConvertAccountNumber
          && String(address.autoConvertAccountNumber).startsWith('U')
      })
      || addresses[0];

    // console.log('getClosestAddressForAccountCurrency', addresses, currency, addr);

    return addr;
  }
}
